import React, { FC, useEffect } from "react";
import Button from "../Button/Button";
import classes from "./Filter.module.css";
import useFilter from "./useFilter";
import Icon from "../Icons/Icon";
import { RootState } from "../../reducers/RootReducer";
import {
  resetFilters,
  setInitialFilterAfterRingOptions,
} from "../../action/FilterAction";
import { connect, ConnectedProps } from "react-redux";
import { FilterProps } from "../../types";
import { ReactComponent as Bookmark } from "../../Utils/images/Bookmark.svg";

const mapStateToProps = (state: RootState) => ({
  filter: state.filter,
  footer: state.footer,
});

const mapDispatchToProps = {
  resetFilters,
  setInitialFilterAfterRingOptions,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromFilterRedux = ConnectedProps<typeof connector>;

const Filter: FC<FilterProps> = ({
                                   isShowFilter,
                                   handleRESETFilters,
                                   resetFilters,
                                   isDisabledFilter,
                                   isReset,
                                   children,
                                   isSetHeight,
                                   filter,
                                   setInitialFilterAfterRingOptions,
                                   footer,
                                   isMobileLayout,
                                   favouriteProducts,
                                   favouritePanel,
                                   isFavouritePanelOpen,
                                   setIsFavouritePanelOpen,
                                 }) => {
  const {
    height,
    handleFilters,
    ref,
    defaultHeight,
    toggleFilter,
    tabletHeight,
    isLargeTablet,
    setIsResetFilter,
    isResetFilter,
  } = useFilter({ isSetHeight, footer, isFavouritePanelOpen });
  const favouriteCount = favouriteProducts?.length ?? 0;
  const showTriggers = +defaultHeight <= +height || isLargeTablet;
  const showFavourites = favouriteCount > 0 && !!setIsFavouritePanelOpen && !!favouritePanel;
  const closeFavourites = () => setIsFavouritePanelOpen?.(false);
  const handleFavourites = () => {
    if (toggleFilter) handleFilters();
    setIsFavouritePanelOpen?.((isOpen) => !isOpen);
  };
  const handleMoreFilters = () => {
    closeFavourites();
    handleFilters();
  };
  useEffect(() => {
    if (isResetFilter) {
      const filterButton = document.querySelector<
        HTMLInputElement | HTMLButtonElement
      >('[name="filterButton"]');
      filterButton && filterButton.focus();
    }
  }, [ isShowFilter ]);
  return (
    <>
      {isShowFilter ? (
        <div
          className={`${
            isLargeTablet ? classes.main_wrp_mobile : classes.main_wrp
          }
            ${!toggleFilter && !isFavouritePanelOpen ? "" : classes.isActive}`}
          id={"filterMain"}
        >
          {showFavourites && favouritePanel ? (
            <div
              style={{ height: isLargeTablet ? (isFavouritePanelOpen ? tabletHeight : 0) : undefined }}
              className={`${classes.main} ${classes.favouriteMain} ${!isFavouritePanelOpen ? "" : classes.isOpen}`}
            >
              <span onClick={closeFavourites} className={classes.overlay}/>
              <div className={classes.root}>
                <div className={classes.container}>{favouritePanel}</div>
                {isMobileLayout ? (
                  <div className={`${classes.items} mt-auto`}>
                    <Button
                      type="button"
                      onClick={closeFavourites}
                      className={classes.done}
                      buttonType="btnPrimary"
                    >
                      Done
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : null}
          <div
            style={{ height }}
            className={`${classes.main} ${!toggleFilter ? "" : classes.isOpen}`}
          >
            <span onClick={handleFilters} className={classes.overlay}/>
            <div className={classes.root} ref={ref}>
              <div className={classes.container}>{children}</div>
              {isMobileLayout ? (
                <div className={`${classes.items} mt-auto`}>
                  <Button
                    type="button"
                    onClick={handleFilters}
                    className={classes.done}
                    buttonType="btnPrimary"
                  >
                    Done
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={`${classes.filtersButton_wrap} ${isFavouritePanelOpen ? classes.favouriteHeader : ""}`}>
            {showTriggers && showFavourites && !toggleFilter ? (
              <Button
                type={"button"}
                name={"favouritesButton"}
                className={`${classes.filtersButton} ${classes.favouritePanelTrigger}`}
                onClick={handleFavourites}
              >
                <span className={classes.favouriteIcon}><Bookmark/></span>
                <span className="text-padding-top">Favorites</span> {/*({favouriteCount})*/}
                <Icon
                  name={isFavouritePanelOpen ? "hk_chevron_up" : ""}
                />
              </Button>
            ) : null}
            {showTriggers && !isFavouritePanelOpen ? (
              <Button
                type={"button"}
                className={`${classes.filtersButton} ${
                  !toggleFilter ? "more_filter" : "less_filter"
                }`}
                name={"filterButton"}
                onClick={handleMoreFilters}
                isDisabled={isDisabledFilter}
              >
                {/*<Icon name={'hk-Filter'} />*/}
                <span>{!toggleFilter ? "More Filters" : "Less Filters"}</span>
                <Icon
                  name={toggleFilter ? "hk_chevron_up" : "hk_chevron_down"}
                />
              </Button>
            ) : null}
            <Button
              id={"reset-filter"}
              type={"button"}
              className={`${classes.filterResetButton}
                   ${isReset ? classes.activeReset : ""}
                `}
              onClick={() => {
                handleRESETFilters();
                setIsResetFilter(true);
              }}
            >
              <span className="text-padding-top">Reset</span>
            </Button>
          </div>
        </div>
      ) : (
        <div className={classes.filterLoading}/>
      )}
    </>
  );
};
export default connector(Filter);
